export const stringHash = (str: string): string => {
    let hash = 0;
    for (const char of str) {
        hash = (hash << 5) - hash + char.charCodeAt(0);
        hash |= 0;
    }
    return (hash >>> 0).toString(36);
};
